// extracted by mini-css-extract-plugin
export var currencyInput = "_jw-1";
export var currencySymbol = "_jw-0";